<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-form-item name="periode_assessment_id" label="Periode Assessment">
            <a-select
              placeholder="Pilih Periode Assessment"
              v-model:value="formState.periode_assessment_id"
              show-search
              :filter-option="filterSelect"
            >
              <a-select-option v-for="option in options.periodeAssessment" :key="option.value">
                {{ option.text }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item name="jabatan" label="Jabatan">
            <a-input v-model:value="formState.jabatan" placeholder="Masukkan Jabatan" />
          </a-form-item>

          <a-form-item name="pog" label="POG">
            <a-input-number v-model:value="formState.pog" placeholder="Masukkan POG" :min="0" />
          </a-form-item>

          <a-form-item name="jumlah_kebutuhan" label="Jumlah Kebutuhan">
            <a-input-number
              v-model:value="formState.jumlah_kebutuhan"
              placeholder="Masukkan Jumlah Kebutuhan"
              :min="1"
            />
          </a-form-item>

          <a-form-item name="jumlah_terisi" label="Jumlah Terisi">
            <a-input-number v-model:value="formState.jumlah_terisi" placeholder="Masukkan Jumlah Terisi" :min="0" />
          </a-form-item>

          <a-form-item name="status" label="Status">
            <a-select v-model:value="formState.status" placeholder="Pilih Status">
              <a-select-option value="vacant">Vacant</a-select-option>
              <a-select-option value="partial">Partial</a-select-option>
              <a-select-option value="filled">Filled</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item name="personal_area" label="Personal Area">
            <a-input v-model:value="formState.personal_area" placeholder="Masukkan Personal Area" />
          </a-form-item>

          <a-form-item name="personal_sub_area" label="Personal Sub Area">
            <a-input v-model:value="formState.personal_sub_area" placeholder="Masukkan Personal Sub Area" />
          </a-form-item>

          <a-form-item name="org_level_1" label="Org Level 1">
            <a-input v-model:value="formState.org_level_1" placeholder="Masukkan Org Level 1" />
          </a-form-item>

          <a-form-item name="org_level_2" label="Org Level 2">
            <a-input v-model:value="formState.org_level_2" placeholder="Masukkan Org Level 2" />
          </a-form-item>

          <a-form-item name="org_level_3" label="Org Level 3">
            <a-input v-model:value="formState.org_level_3" placeholder="Masukkan Org Level 3" />
          </a-form-item>

          <a-form-item name="org_level_4" label="Org Level 4">
            <a-input v-model:value="formState.org_level_4" placeholder="Masukkan Org Level 4" />
          </a-form-item>

          <a-form-item name="id_organisasi_unit" label="Unit Organisasi">
            <a-select
              placeholder="Pilih Unit Organisasi"
              v-model:value="formState.id_organisasi_unit"
              show-search
              :filter-option="filterSelect"
            >
              <a-select-option v-for="option in options.organisasiUnit" :key="option.value">
                {{ option.text }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>
                <router-link to="/assessment/master/proyeksi-jabatan">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../../components/crud/style';
import { Main } from '../../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

const ProyeksiJabatanForm = {
  name: 'ProyeksiJabatanForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);

    const formState = reactive({
      periode_assessment_id: undefined,
      jabatan: '',
      pog: 0,
      jumlah_kebutuhan: 1,
      jumlah_terisi: 0,
      status: 'vacant',
      personal_area: '',
      personal_sub_area: '',
      org_level_1: '',
      org_level_2: '',
      org_level_3: '',
      org_level_4: '',
      id_organisasi_unit: undefined,
    });

    const options = reactive({
      periodeAssessment: [],
      organisasiUnit: [],
    });

    const rules = {
      periode_assessment_id: [{ required: true, message: 'Periode Assessment harus diisi' }],
      jabatan: [{ required: true, message: 'Jabatan harus diisi' }],
      pog: [{ required: true, message: 'POG harus diisi' }],
      jumlah_kebutuhan: [{ required: true, message: 'Jumlah Kebutuhan harus diisi' }],
      status: [{ required: true, message: 'Status harus diisi' }],
      id_organisasi_unit: [{ required: true, message: 'Unit Organisasi harus diisi' }],
    };

    const labelCol = {
      lg: { span: 6 },
      md: { span: 9 },
      xs: { span: 24 },
    };
    const wrapperCol = {
      lg: { span: 18 },
      md: { span: 15 },
      xs: { span: 24 },
    };

    const filterSelect = (input, option) => {
      return option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    // Watch for changes in jumlah_kebutuhan and jumlah_terisi to update status
    watch([() => formState.jumlah_kebutuhan, () => formState.jumlah_terisi], ([kebutuhan, terisi]) => {
      if (terisi === 0) {
        formState.status = 'vacant';
      } else if (terisi < kebutuhan) {
        formState.status = 'partial';
      } else {
        formState.status = 'filled';
      }
    });

    onMounted(() => {
      // Get periode assessment options
      dispatch('axiosCrudGetData', 'periode-assessment').then(() => {
        options.periodeAssessment = crud.value;
      });

      // Get organisasi unit options
      dispatch('axiosCrudGetData', 'organisasi-unit').then(() => {
        options.organisasiUnit = crud.value;
      });

      // If edit mode, get existing data
      if (props.mode === 'Ubah' && params.id) {
        dispatch('axiosCrudGetData', `proyeksi-jabatan/${params.id}`).then(() => {
          Object.assign(formState, crud.value);
        });
      }
    });

    const handleSubmit = values => {
      if (props.mode === 'Tambah') {
        dispatch('axiosDataPost', {
          values,
          url: 'proyeksi-jabatan',
          redirect: '/assessment/master/proyeksi-jabatan',
        });
      } else {
        dispatch('axiosDataPut', {
          values,
          url: `proyeksi-jabatan/${params.id}`,
          redirect: '/assessment/master/proyeksi-jabatan',
        });
      }
    };

    return {
      formState,
      options,
      rules,
      labelCol,
      wrapperCol,
      isLoading,
      filterSelect,
      handleSubmit,
    };
  },
};

export default ProyeksiJabatanForm;
</script>

<style lang="scss" scoped>
.sDash_form-action {
  margin-top: 40px;
  &__btn:not(:last-child) {
    margin-right: 20px;
  }
}
</style>
